// removed by extract-text-webpack-plugin
module.exports = {"container":"app-pages-Library-Item-ItemDetail-ItemForm-SaveToAllOutletsModal-__SaveToAllOutletsModal___Z2LOc","title":"app-pages-Library-Item-ItemDetail-ItemForm-SaveToAllOutletsModal-__SaveToAllOutletsModal___3vSDz"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Library/Item/ItemDetail/ItemForm/SaveToAllOutletsModal/SaveToAllOutletsModal.css
// module id = 2180
// module chunks = 0